import React from 'react';
import {
  List,
  Create,
  SimpleForm,
  TextInput,
  LongTextInput,
  SelectInput,
  ReferenceArrayInput,
  // BooleanInput,
  Toolbar,
  SaveButton,
  ReferenceInput,
  translate as t,
  Filter,
  Datagrid,
  RadioButtonGroupInput,
  TextField,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import SelectArrayInput from '../components/inputs/SelectArrayInput';
import ImageInput from '../components/inputs/ImageInput';
import ProvisionalStateInput from '../components/inputs/ProvisionalStateInput';
// import References from '../components/References';
// import RecipeBuilder from '../components/RecipeBuilder';
import { Section } from '../components/utils/Section';
// import If from '../components/utils/If';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';

const ProvisionalProductFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Category" source="category" reference="categories" allowEmpty alwaysOn>
      <SelectInput optionText={<Title {...props} />} />
    </ReferenceInput>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

export const ProvisionalProductList = (props) => {
  const { user } = props;

  return (
    <List
      {...props}
      filters={<ProvisionalProductFilter />}
      filter={
        !user.superUser && user.venues.length > 0
          ? {
            provisional: true,
            $or: [
              { submittedBy: user.phoneNumber },
              { 'provisionalData.venues': { $in: user.venues } },
              { 'provisionalData.venues': { $size: 0 } },
            ],
          } : { provisional: true }
      }
      perPage={15}
    >
      <Datagrid>
        <TextField source="internalName" />
        <TextField source="provisionalData.state" />
        <EditButton {...props} basePath="/provisional-products" property="code" />
        <DeleteButton {...props} basePath="/provisional-products" property="code" />
      </Datagrid>
    </List>
  );
};

const ProvisionalProductTitle = t(({ record, translate, locale }) => (
  <span>{record ? translate('edit.title', { title: getTranslationByLocale(record.title, locale) }) : ''}</span>
));

const Title = t(({ record, locale }) => (getTranslationByLocale(record.title, locale)));

const ProvisionalProductToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton basePath="/provisional-products" />
  </Toolbar>
);

const mainCategories = [{ id: 'food', name: 'food' }, { id: 'drink', name: 'drink' }];

const Form = t((props) => (
  <SimpleForm
    {...props}
    toolbar={<ProvisionalProductToolbar {...props} />}
    defaultValue={{ originalMarketCountryCode: props.user && props.user.venues && props.user.venues[0] ? props.user.venues[0].substr(0, 2).toUpperCase() : 'SE', contents: [], provisionalData: { venues: props.user && props.user.venues && props.user.venues.length ? props.user.venues : [] } }}
    // redirect={`/products/${window.location.hash.replace('#/provisional-products/', '')}`}
  >
    <Section title="provisional-products.preliminary-form">
      <a href="https://forms.gle/R8pMHuJmd7Y7PdEJ9">https://forms.gle/R8pMHuJmd7Y7PdEJ9</a>
    </Section>
    {
      props.action === 'edit' &&
        props.permissions.superUser &&
          <ProvisionalStateInput {...props} addField source="provisionalData.state" choices={[{ id: 'new', name: 'new' }, { id: 'rejected', name: 'rejected' }, { id: 'accepted', name: 'accepted' }]} />
    }
    <LongTextInput source="provisionalData.discussion" />
    {
      props.action === 'edit' &&
        props.permissions.superUser &&
        <TextInput
          options={{ fullWidth: true, errorText: props.translate('internalNameHint'), errorStyle: { color: 'darkslategrey' }, floatingLabelFocusStyle: { color: 'darkslategrey' } }}
          source="internalName"
        />
    }
    <RadioButtonGroupInput source="mainCategory" choices={mainCategories} />
    <ReferenceInput format={(category) => category && category._id} source="category" reference="categories" filter={{ promotion: { $ne: true } }} allowEmpty perPage={9999}>
      <SelectInput optionText={(choice) => getTranslationByLocale(choice.title, props.locale)} options={{ fullWidth: true }} />
    </ReferenceInput>
    <ReferenceArrayInput {...props} source="stations" reference="stations" allowEmpty>
      <SelectArrayInput optionText={(choice) => getTranslationByLocale(choice.title, props.locale)} options={{ fullWidth: true }} />
    </ReferenceArrayInput>
    <LongTextInput source="title" format={(title) => (title && title[0] && title[0].content)} parse={(content) => ([{ lang: 'sv', content }, { lang: 'en' }, { lang: 'nb' }, { lang: 'da' }, { lang: 'fi' }])} {...props} />
    <LongTextInput source="subtitle" format={(subtitle) => (subtitle && subtitle[0] && subtitle[0].content)} parse={(content) => ([{ lang: 'sv', content }, { lang: 'en' }, { lang: 'nb' }, { lang: 'da' }, { lang: 'fi' }])} {...props} />

    <TextInput
      source="priceSuggestion"
      label="markets.suggestedPrice"
    />


    <Section title="resources.products.fields.productContents">
      { // <References references={[{ name: 'ingredients' }, { name: 'recipes', filter: { product: props.record.id } }, { name: 'suppliers' }]} {...props}>
      //   <RecipeBuilder source="contents" {...props} />
      // </References>
      }

      <LongTextInput source="listOfContent" label={props.translate('resources.products.fields.listOfContent')} />
      <ReferenceArrayInput
        {...props}
        source="allergens"
        reference="allergens"
        allowEmpty
      >
        <SelectArrayInput
          optionText={(choice) => getTranslationByLocale(choice.title, props.locale)}
          options={{ fullWidth: true }}
        />
      </ReferenceArrayInput>
      <ReferenceArrayInput
        {...props}
        source="servingPlatter"
        reference="ingredients"
        filter={{ edible: false }}
        label={props.translate('resources.products.fields.servingPlatter')}
        allowEmpty
      >
        <SelectArrayInput
          optionText={(choice) => choice.description}
          options={{ fullWidth: true }}
        />
      </ReferenceArrayInput>
      <LongTextInput source="ingredients" label={props.translate('resources.products.fields.ingredientsWithHint')} />
      <LongTextInput source="instructions" label={props.translate('resources.products.fields.instructions')} />
      <LongTextInput source="servingWeight" label={props.translate('resources.products.fields.servingWeight')} />
      <LongTextInput source="costPerPortion" label={props.translate('resources.products.fields.costPerPortion')} />
    </Section>
    <ImageInput source="provisionalImageUrl" accept="image/*">
      <ThumbnailImageField source="src" />
    </ImageInput>
  </SimpleForm>
));

export const ProvisionalProductEdit = (props) => (
  <Edit title={<ProvisionalProductTitle />} {...props}>
    <Form {...props} action="edit" />
  </Edit>
);

export const ProvisionalProductCreate = (props) => (
  <Create {...props}>
    <Form {...props} action="create" />
  </Create>
);
